import React from "react";
import logo from "./logo.svg";
import { useTranslation } from "react-i18next";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import "./IntroductionScreen.scss";
import { Link } from "react-router-dom";
import image from "./images/introduction-mobile.png";

function IntroductionScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="introduction-screen-container">
      <div className="mobile-hero">
        <img src={image} alt="woman on the street talking on a phone" />
      </div>
      <div className="introduction-screen-white-gradient">
        <div className="container introduction-screen-text-container">
          <h2 className="blue-header">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Introduction.title_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </h2>
          <p>{t("Introduction.subtitle")}</p>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/challenges" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default IntroductionScreen;
